import React, { useState, useEffect, PropTypes } from "react"
import Select from 'react-select';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import $ from "jquery/dist/jquery.min.js";
import qs from "qs"
import { isMobile, browserName, isTablet } from "react-device-detect";
import SearchPage from "../components/SearchResult/SearchResult";
// import MapResultsDesktop from "../components/map/search-results-desktop-map";
import MapMobile from "../components/map/search-results-mobile";
import SeoResults, { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "../components/Property-search/seoResults"
import HTMLReactParser from "html-react-parser";
import infoIcon from "../images/info-p.png"

//import PropertyCard from "../components/PropertyCard/PropertyCard"
import SearchList from "../components/SearchResult/SearchList/SearchList";
import SearchListBox from "../components/SearchResult/SearchList/SearchBox";
import SearchFilter from "../components/SearchResult/SearchList/SearchFilter";
import FilterBlock from "../components/SearchResult/FilterBlock/FilterBlock";

// import image from "../images/property-image.jpg"
import IncludeSold from "../components/search/filterSold"
// Myaccount
import { UserObjectStoreProvider, SaveItem, getUserobjectData, isAuthenticated, savedSearchParams } from "@starberry/myaccount-website-utils";


import algoliasearch from "algoliasearch/lite"
import {
  parseSearchUrl,
  propertyH1,
  // savedSearchParams
} from "../components/Property-search/utils";
import {
  connectStats,
  SortBy,
  connectInfiniteHits,
  connectToggleRefinement,
  InstantSearch,
  RefinementList,
  connectSearchBox,
  connectMenu,
  connectRange,
  Configure,
  ToggleRefinement,
  connectSortBy,
  ClearRefinements,
  connectAutoComplete,
  connectStateResults,
  CurrentRefinements
} from "react-instantsearch-dom"
import {
  GoogleMapsLoader,
  GeoSearch,
  Marker,
  CustomMarker
} from 'react-instantsearch-dom-maps'
import Cookies from 'universal-cookie'
import { Link } from "@StarberryUtils";
import { navigate } from "@reach/router";
import Logo from '../images/icon.png';
import _ from "lodash";
import logoBlack from "../images/logoblack.svg";
import Loadable from "@loadable/component"

import { inViewOptions, containerVariants, fadeInFromRight, fadeInFromBottom, fadeInFromTop } from '../components/Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const MapResultsDesktop = Loadable(() => import("../components/map/search-results-desktop-map"));

const mycookies = new Cookies();
const updateAfter = 500

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""
var includeSold = false;
const searchClient = algoliasearch(
  "ZVQH8NJ7TK",
  `${process.env.GATSBY_ALGOLIA_SEARCH_KEY}`
)

const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`

let arrow = false
let filter = false

const LoadingIndicator = connectStateResults(
  ({ isSearchStalled }) =>
    isSearchStalled ? (
      <div className="static-details gql-loading-screen my-5">
        <Container>
          {/* <img src={Logo} alt="DB Roberts" width="100" />
          <div className="gql-loading">Loading ...</div> */}

          <section className={"loader-wrapper1"}>
            <div id="loader-wrapper1">
              <div id="loader1" class="new-loader1">
                {/* <div className="new-loader-anime1"></div> */}
                <img className="logo-white" src={logoBlack} className="loader-logo1" alt="DB Roberts logo" />
              </div>
              <div class="loader-section section-left"></div>
              <div class="loader-section section-right"></div>
            </div>
          </section>

        </Container>
      </div>
    ) : <CustomNoStats />
);

// Property results loop
const InfiniteHits = ({
  hits,
  hasPrevious,
  refinePrevious,
  hasMore,
  refineNext,
  location,
  userObjects
}) => {

  return (
    <div className="search-list-block ">
      <Container>
        {(hits.length > 0 && hasPrevious) && (
          <button
            id="myprevbut"
            onClick={refinePrevious}
            disabled={!hasPrevious}
            className="d-none property_show_more_btn"
          >
            Show prev
          </button>
        )}

        {
          hits.map((hit, i) => {



            // property details url structure
            let uriStr = "";
            let mysale = "";

            if (hit.searchType === "sales" && hit.department === 'residential') {
              uriStr = `property-for-sale/`
              mysale = `myResSaleProp`
            }
            else if (hit.searchType === "lettings" && hit.department === 'residential') {
              uriStr = `property-to-rent/`
              mysale = `myResRentProp`
            }
            // property details url structure

            return (
              <UserObjectStoreProvider>
                <div className="mysingleproperty" key={i} id={`${mysale}${hit.objectID}`} data-objectid={hit.objectID} data-lat={hit?._geoloc?.lat} data-lng={hit?._geoloc?.lng}>

                  <SearchList
                    images={hit.images}
                    floorplan={hit.floorplan}
                    BedCount={hit.bedroom}
                    BathCount={hit.bathroom}
                    PropertyReception={hit.reception}
                    searchType={hit.searchType}
                    Status={hit.status}
                    areaNumber={hit.floor_area}
                    //areaSup={hit.areaSup}
                    PropertyPrice={hit.price}
                    priceQualifier={hit.price_qualifier}
                    people={hit.negotiator_details}
                    PropertyHeading={hit.title}
                    PropertyLocation={hit.display_address}
                    PropertyDescription={hit.description}
                    disposal={hit.disposal}
                    unique_key={hit.objectID}
                    mycookies={mycookies}
                    url={`/${uriStr}${hit.slug}-${hit.objectID}`}
                    objectID={hit.objectID}
                    mysale={mysale}
                    negotiatorId={hit.negotiatorId}
                    userObjects={userObjects}
                  />
                </div>
              </UserObjectStoreProvider>
            )
          })}
        <Row id="search-load-more">
          <Col className="text-center load-more-btn learn-more">
            {(hits.length > 0 && hasMore) && (
              <Button
                id="mynextbut"
                onClick={refineNext}
                disabled={!hasMore}
                variant="outline" className="btn btn-view"

              >
                Load more
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    </div>

  )
}

const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)
// Property results loop

// Searchbox
const SearchBox = connectSearchBox(({ currentRefinement, refine }) => {
  return (
    <div className="search-box">
      <Form.Control type="search"
        placeholder="Street, area or postcode"
        id="formBasicEmail"
        onChange={event => refine(event.currentTarget.value.replace(/,/g, " ").replace(/'/g, "").replace(/\s+/g, ' ').replace(/ /g, "-").toLowerCase())}
        value={currentRefinement.replace(/\s+/g, ' ').replace(/-/g, ' ')}
      />
      <i className="icon-search">
      </i>
    </div>
  )
})
// Searchbox

// Property Bedrooms
const bedroomSelectBox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
}) => {

  let bedroomvalselect = ""
  if (currentRefinement.max !== undefined) {
    bedroomvalselect = 0
  } else if (currentRefinement.min !== undefined) {
    bedroomvalselect = currentRefinement.min
  }

  let options = [
    { value: "", label: "Any" },
    { value: '1', label: '1 +' },
    { value: '2', label: '2 +' },
    { value: '3', label: '3 +' },
    { value: '4', label: '4 +' },
    { value: '5', label: '5 +' }
  ]

  return (
    <Select
      name="beds"
      options={options}
      defaultValue={{ value: "", label: "Any" }}
      value={{ label: bedroomvalselect ? options.filter(c => c.value == bedroomvalselect)[0].label : "Beds", value: bedroomvalselect ? bedroomvalselect : "" }}
      placeholder="Beds"
      classNamePrefix={"select-opt"}
      styles={styles}
      onChange={(e) => {
        if (e.value === "") {
          refine(e.value, e.label)
        } else if (e.value === "0") {
          refine({
            max: e.value,
          })
        } else {
          refine({
            min: e.value,
          })
        }
      }}
      isSearchable={false}
    />
  )
}

const CustombedroomSelectbox = connectRange(bedroomSelectBox)
// Property Bedrooms
// Property type
const buildingSelectbox = ({ items, currentRefinement, refine }) => {
  return (


    <Select
      name="building"
      options={[
        { value: "", label: "All" },
        { value: "house", label: "Houses" },
        { value: "apartment", label: "Apartments" },
        { value: "bungalow", label: "Bungalows" },
        { value: "maisonette", label: "Maisonettes" },
        //   { value: "Penthouse", label: "Penthouse" },
        //   { value: "House,Bunagalo", label: "House, Bunagalo" },
        { value: "land", label: "Land" },
        { value: "leasehold interest", label: "Leasehold Interests" },
        { value: "auction", label: "Auctions" },
        { value: "private treaty", label: "Private Treaty" },
        { value: "shared ownership", label: "Shared Ownership" },
        //   { value: "full-floor", label: "Full floor" },
        //   { value: "hotel-apartment", label: "Hotel/Hotel Apartment" },
        //   { value: "shop", label: "Shop" }
        // { value: "property", label: "Others" },
        //   { value: "apartment", label: "Apartment/ Flat" },
        //   { value: "bungalows", label: "Bungalow" },
        //   { value: "detached house", label: "Detached House" },
        // { value: "semi-detached-house", label: "Semi Detached House" },
        //   { value: "terraced", label: "Terraced House" }
      ]}
      defaultValue={{ value: 0, label: "All" }}
      value={{ label: currentRefinement ? _.startCase(_.toLower(currentRefinement.replace(/-/g, ' '))) : "All", value: currentRefinement ? currentRefinement.replace(/-/g, ' ') : "" }}
      placeholder="Property Type"
      classNamePrefix={"select-opt"}
      onChange={(e) => { refine(e.value, e.label) }}
      isSearchable={false}
      styles={styles}
    />
  )
}

const CustombuildingSelectbox = connectMenu(buildingSelectbox)
// Property type


// Sort by
// Sort by
const SortByPrice = ({ items, currentRefinement, refine }) => (
  <>
    {items.map((item, key) => {
      return (
        <a href="javascript:void(0)" key={key} className={item.class} onClick={event => {
          event.preventDefault();
          refine(item.value);
        }}>
          {
            item.class === "property_sortby_asc" ?
              <div className="price-short-filter" >
                <i className="short-icon"></i>
                <span className="toggle-text">Lowest <span className="d-none d-sm-inline-block">Price First</span></span>
              </div>


              :
              <div className="price-short-filter" >
                <i className="short-icon short-icon-low"></i>
                <span className="toggle-text">Highest <span className="d-none d-sm-inline-block">Price First</span></span>
              </div>


          }
        </a>
      )
    })}
  </>
)

const CustomSortBy = connectSortBy(SortByPrice);
// Sort by


// No Results
const NoStats = ({ processingTimeMS, nbHits }) => {
  return (
    <>
      {nbHits === 0 &&
        <div className="no-result">
          <h4>Unfortunately, we do not currently have any properties that match your search criteria.</h4>
        </div>
      }
    </>
  )
}

const CustomNoStats = connectStats(NoStats)
// No Results

// Results count
const Stats = ({ processingTimeMS, nbHits }) => <>{nbHits}</>

const CustomStats = connectStats(Stats)
// Results count


// Create URL
export const createURL = (props, state, location) => {
  let myarea = state.menu

  const isDefaultRoute =
    !state.query &&
    !state.SortBy &&
    state.page === 1 &&
    state.menu &&
    state.range &&
    !state.range.price &&
    !state.range.bedroom

  if (isDefaultRoute) {
    return ""
  }

  var areaPath = ""
  var bedroomPath = ""
  var pricePath = ""
  var pagePath = ""
  var propertypath = ""
  var sortPath = ""

  if (state.query) {
    if (state.query) {
      areaPath = "in-" + encodeURIComponent(decodeURIComponent(state.query)) + "/"
    }
  }

  const queryParameters = {}

  // Property path
  if (state.menu) {
    if (myarea["building"]) {
      propertypath = "type-" + myarea["building"].replace(/ /g, '-') + "/"
    }
    if (myarea["tenure"]) {
      if(myarea["tenure"] == 'leasehold') {
        propertypath = "type-leasehold-interest/"
      }else {
        propertypath = "type-" + myarea["tenure"].replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase() + "/";
      }
   }
   if (myarea["disposal"]) {
      propertypath = "type-" + myarea["disposal"].replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase() + "/";
   }
  }
  // Property path

  // Bedrooms & Price range path
  if (state.range) {
    // Bedrooms
    if (state.range.hasOwnProperty('bedroom') && state.range.bedroom.max === 0) {
      bedroomPath = "studio/" //queryParameters.price_max = state.range.price.max;
    }
    if (state.range.bedroom) {
      if (state.range.bedroom.min) {
        bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/" //queryParameters.price_max = state.range.price.max;
      }
    }

    // Price
    if (state.range.price) {
      if (state.range.price.min && state.range.price.max) {
        pricePath = "between-" + state.range.price.min + "-and-" + state.range.price.max + '/' //queryParameters.price_min = state.range.price.min;
      } else if (state.range.price.max) {
        pricePath = "below-" + state.range.price.max + '/' //queryParameters.price_max = state.range.price.max;
      } else if (state.range.price.min) {
        pricePath = "above-" + state.range.price.min + '/' //queryParameters.price_max = state.range.price.max;
      }
    }
  }
  // Bedrooms & Price range path

  // Sort path
  if (state.sortBy) {
    if (state.sortBy === index_name) {
      sortPath = "sortby-price-asc/";
    }
    if (state.sortBy === index_name + "_price_desc") {
      sortPath = "sortby-price-desc/";
    }
    if (state.sortBy === index_name + "_most_recent") {
      sortPath = "sortby-most-recent/";
    }
  }
  // Sort path

  // Page path
  if (state.page && state.page !== 1) {
    pagePath = `page-${state.page}/`
  }
  // Page path

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: "repeat",
  })

  let myUrl = `${areaPath}${propertypath}${bedroomPath}${pricePath}${queryString}${pagePath}${sortPath}`;

  // console.log(myUrl, "myUrl")


  if ("/" === myUrl.substr(myUrl.length - 1))
    myUrl = myUrl.substr(0, myUrl.length - 1)

  return `${location}${myUrl}`
}
// Create URL

// URL to searchstate
const searchStateToUrl = (props, searchState, location) =>
  searchState ? `${createURL(props, searchState, location)}` : ""

const urlToSearchState = location => {
  if (location) {
    var query = ""
    let pathUri_main = ''

    let a1 = location.pathname.indexOf("/property/for-sale") > -1
    let a2 = location.pathname.indexOf("/property/to-rent") > -1
    if (a1 == true) {
      pathUri_main = location.pathname.split("/property/for-sale")
    }
    else if (a2 == true) {
      pathUri_main = location.pathname.split("/property/to-rent")
    }
    else {
      pathUri_main = location.pathname.split(location)
    }

    var areaVal = ""
    var bedVal = 10
    var minpriceVal = ""
    var maxpriceVal = ""
    var pageVal = ""
    var propertyval = ""
    var sortVal = ""
    var sortVal_filt = ""

    if (pathUri_main[1]) {
      // following could be regexp
      let pathUri = pathUri_main[1].split("/")

      //lets loop
      for (let vi = 1; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }

        // Property type
        if (pathUri[vi].indexOf("type-") >= 0) {
          propertyval = pathUri[vi].replace("type-", "")
        }

        // Area
        if (pathUri[vi].indexOf("in-") >= 0) {
          areaVal = pathUri[vi].replace("in-", "").replace(/-branch-areas/gi, ' ').replace(/-town-centre/gi, '')
        }


        // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("above-") >= 0 ||
          pathUri[vi].indexOf("below-") >= 0
        ) {
          let priceFilt1 = pathUri[vi].split("above-")
          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1]
          }
          let priceFilt2 = pathUri[vi].split("below-")
          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1]
          }
          let priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
            let priceFilt4 = priceFilt3[1].split("-and-")
            minpriceVal = priceFilt4[0]
            maxpriceVal = priceFilt4[1]
          }
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
        }

        if (pathUri[vi].indexOf("studio") >= 0) {
          // its studio bedroom
          bedVal = 0
        }

        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          sortVal_filt = pathUri[vi].replace("sortby-", "")

          if (sortVal_filt === "price-asc") {
            sortVal = index_name
          }

          if (sortVal_filt === "price-desc") {
            sortVal = index_name + "_price_desc"
          }

          if (sortVal_filt === "most-recent") {
            sortVal = index_name + "_most_recent"
          }
        }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }
      }
    }
  }

  // Property type
  if (propertyval) {
    if (propertyval == "leasehold-interest") {
      query += `&menu[tenure]=leasehold`
    }else if(propertyval == "auction") {
      query += `&menu[disposal]=auction`
    } else if(propertyval == "private-treaty") {
      query += `&menu[disposal]=privateTreaty`
    } else if(propertyval == "shared-ownership") {
      query += `&menu[disposal]=sharedOwnership`
    }else {
      query += `&menu[building]=` + propertyval
    }

  }
  
  // Area
  if (areaVal) {
    areaVal = areaVal.toLowerCase();
    query += `&query=` + areaVal
    // if (areaVal == "cannock") query += `&query=`
    // else query += `&query=` + areaVal
  }

  // Price
  if (minpriceVal) {
    query += `&range[price][min]=` + minpriceVal
  }

  if (maxpriceVal) {
    query += `&range[price][max]=` + maxpriceVal
  }

  // Bedrooms
  if (bedVal == 0) {
    query += `&range[bedroom][min]=` + 0
  } else if (bedVal < 10) {
    query += `&range[bedroom][min]=` + bedVal
  }

  // Page
  if (pageVal) {
    query += `&page=${pageVal}`
  }

  // Sort by
  if (sortVal) {
    query += `&sortBy=` + sortVal
  }

  return qs.parse(query)
}
// URL to searchstate

// Min Price
const priceminRange = [
  {
    value: "0",
    label: "No Min"
  },
  {
    value: "25000",
    label: "£25,000"
  },
  {
    value: "50000",
    label: "£50,000"
  },
  {
    value: "75000",
    label: "£75,000"
  },
  {
    value: "100000",
    label: "£100,000"
  },
  {
    value: "125000",
    label: "£125,000"
  },
  {
    value: "150000",
    label: "£150,000"
  },
  {
    value: "175000",
    label: "£175,000"
  },
  {
    value: "200000",
    label: "£200,000"
  },
  {
    value: "225000",
    label: "£225,000"
  },
  {
    value: "250000",
    label: "£250,000"
  },
  {
    value: "275000",
    label: "£275,000"
  },
  {
    value: "300000",
    label: "£300,000"
  },
  {
    value: "350000",
    label: "£350,000"
  },
  {
    value: "400000",
    label: "£400,000 +"
  }
]

const priceminRangeLettings = [
  {
    value: "0",
    label: "No Min"
  },
  {
    value: "350",
    label: "£350 PCM"
  },
  {
    value: "400",
    label: "£400 PCM"
  },
  {
    value: "450",
    label: "£450 PCM"
  },
  {
    value: "500",
    label: "£500 PCM"
  },
  {
    value: "550",
    label: "£550 PCM"
  },
  {
    value: "600",
    label: "£600 PCM"
  },
  {
    value: "700",
    label: "£700 PCM"
  },
  {
    value: "800",
    label: "£800 PCM"
  },
  {
    value: "900",
    label: "£900 PCM"
  },
  {
    value: "1000",
    label: "£1000 PCM"
  },
  {
    value: "1250",
    label: "£1250 PCM"
  },
  {
    value: "1500",
    label: "£1500 PCM"
  },
  {
    value: "1750",
    label: "£1750 PCM"
  },
  {
    value: "2000",
    label: "£2000 PCM"
  }
]

const styles = {
  control: styles => ({ ...styles, backgroundColor: '#f7fbff', border: 0, outline: 0, boxShadow: 'none', fontSize: '14px', color: '#263140', minHeight: '3rem', paddingLeft: '1rem', marginBottom: '1rem' }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#263140',
    }
  }
}

const minpriceSelectbox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
  type
}) => {
  var minPriceRange = priceminRange;
  if (type === "lettings") {
    minPriceRange = priceminRangeLettings;
  }
  if (currentRefinement.max !== undefined && currentRefinement.max != "0") {
    minPriceRange = minPriceRange.filter((x) => parseInt(x.value) < parseInt(currentRefinement.max))
  }

  minpriceval = currentRefinement.min
  return (
    <Select
      name="minprice"
      options={minPriceRange}
      //   defaultValue={currentRefinement.min || "0"}
      //   defaultValue={{ value: "0", label: "Min Price" }}
      value={{ label: currentRefinement.min ? minPriceRange.filter(c => c.value == currentRefinement.min)[0].label : "Min Price", value: currentRefinement.min ? currentRefinement.min : "" }}
      isSearchable={false}
      placeholder="Min Price"
      classNamePrefix={"select-opt"}
      onChange={(e) => {
        minpriceval = e.value
        if (e.value === "0") {
          if (maxpriceval !== "0") {
            refine({
              max: maxpriceval,
            })
          } else refine(e.value, e.label)
        } else {
          refine({
            min: e.value,
            max: maxpriceval,
          })
        }
      }}
      //components={{ DropdownIndicator:() => <SelectArrow />, IndicatorSeparator:() => null }}
      styles={styles}
    />
  )
}

const CustomminpriceSelectbox = connectRange(minpriceSelectbox)
// Min Price

// Max Price

const pricemaxRangeLettings = [{ "value": "0", "label": "No Max" }, { "value": "2000", "label": "£2000 PCM" }, { "value": "1750", "label": "£1750 PCM" }, { "value": "1500", "label": "£1500 PCM" }, { "value": "1250", "label": "£1250 PCM" }, { "value": "1000", "label": "£1000 PCM" }, { "value": "900", "label": "£900 PCM" }, { "value": "800", "label": "£800 PCM" }, { "value": "700", "label": "£700 PCM" }, { "value": "600", "label": "£600 PCM" }, { "value": "550", "label": "£550 PCM" }, { "value": "500", "label": "£500 PCM" }, { "value": "450", "label": "£450 PCM" }, { "value": "400", "label": "£400 PCM" }, { "value": "350", "label": "£350 PCM" }]

const pricemaxRange = [
  { value: "0", label: "No Max" },
  { value: "1000000", label: "£ 1,000,000" },
  { value: "900000", label: "£ 900,000" },
  { value: "800000", label: "£ 800,000" },
  { value: "700000", label: "£ 700,000" },
  { value: "600000", label: "£ 600,000" },
  { value: "500000", label: "£ 500,000" },
  { value: "400000", label: "£ 400,000" },
  { value: "350000", label: "£ 350,000" },
  { value: "300000", label: "£ 300,000" },
  { value: "275000", label: "£ 275,000" },
  { value: "250000", label: "£ 250,000" },
  { value: "225000", label: "£ 225,000" },
  { value: "200000", label: "£ 200,000" },
  { value: "175000", label: "£ 175,000" },
  { value: "150000", label: "£ 150,000" },
  { value: "125000", label: "£ 125,000" },
  { value: "100000", label: "£ 100,000" },
  { value: "75000", label: "£ 75,000" },
  { value: "50000", label: "£ 50,000" }
]

const maxpriceSelectbox = ({
  currentRefinement,
  min,
  max,
  precision,
  refine,
  type
}) => {
  var maxPriceRange = pricemaxRange;
  if (type === "lettings") {
    maxPriceRange = pricemaxRangeLettings;
  }
  let maxpricedisable = ''
  if (currentRefinement.min !== undefined) {
    maxPriceRange = maxPriceRange.filter((x) => x.value == "0" || parseInt(x.value) > parseInt(currentRefinement.min))
  }
  if (currentRefinement.min == "400000") {
    maxpricedisable = 'disabled'
  }
  maxpriceval = currentRefinement.max
  return (
    <Select
      name="maxprice"
      options={maxPriceRange}
      //   defaultValue={currentRefinement.max || "0"}
      defaultValue={{ value: "0", label: "Max Price" }}
      value={{ label: currentRefinement.max ? maxPriceRange.filter(c => c.value == currentRefinement.max)[0].label : "Max Price", value: currentRefinement.max ? currentRefinement.max : "" }}
      placeholder="Max Price"
      classNamePrefix={"select-opt"}
      isSearchable={false}
      onChange={(e) => {
        maxpriceval = e.value
        if (e.value === "0") {
          if (minpriceval) {
            refine({
              min: minpriceval,
            })
          } else refine(e.value, e.label)
        } else {
          refine({
            min: minpriceval,
            max: e.value,
          })
        }
      }}
      //components={{ DropdownIndicator:() => <SelectArrow />, IndicatorSeparator:() => null }}
      styles={styles}
    />
  )
}

const CustommaxpriceSelectbox = connectRange(maxpriceSelectbox)

const ToggletttRefinement = ({
  currentRefinement,
  label,
  count,
  refine,
  createURL,
}) => {
  return (
    <a
      href={'#'}
      onClick={event => {
        event.preventDefault();
        includeSold = !includeSold;
        refine(!currentRefinement);
      }}
    >
      <div className="switch-button ">
        <label for="toggle-button">
          <input type="checkbox" id="toggle-button" checked={includeSold ? "checked" : ""} />
          <span className="toggle-switch">
            <span className="toggle-switch-bar"></span>
          </span>
          <span className="toggle-text">{label}</span>
        </label>
      </div>
    </a>
  )
}



const CustomToggleRefinement = connectToggleRefinement(ToggletttRefinement);

class PropertySearchSales extends React.Component {

  constructor(props) {
    super(props);
    includeSold = false

  }


  //
  state = {
    searchState: urlToSearchState(typeof window !== 'undefined' ? window.location : ''),
    userObjects: {},
    show: false,
    arrow: false,
    input: false,
    filter: false,
    filterOpen: false,
    showDesc: false,
    includeSoldinside: false,
    includeLetinside: false
  }





  setShow = () => {
    this.setState({ show: !this.state.show })
  }


  filterRefine = () => {
    this.setState({ filter: !this.state.filter })
  }

  inputClick = () => {
    this.setState({ input: !this.state.input })
  }

  arrowClick = () => {
    this.setState({ arrow: !this.state.arrow })
  }
  filterClick = () => {
    this.setState({ filterOpen: !this.state.filterOpen })
  }




  componentDidUpdate(prevProps) {

    if (prevProps.location !== this.props.location) {

      this.setState({ searchState: urlToSearchState(this.props.location) })
    }
  }

  onSearchStateChange = searchState => {
    clearTimeout(this.debouncedSetState)
    this.debouncedSetState = setTimeout(() => {
      navigate(searchStateToUrl(this.props, searchState, this.props.locationname), searchState)
    }, updateAfter)
    this.setState({ searchState })
  }

  
  includeSoldclick = e => {
    this.setState({
      includeSoldinside: !this.state.includeSoldinside
    })
  }

  includeLetclick = e => {
    this.setState({
      includeLetinside: !this.state.includeLetinside
    })
  }


  onSearchStateChange2 = (searchState) => {
    this.setState({ searchState })
  }

  //

  componentDidMount() {





    $(document).mouseup(function (e) {
      var container = $(".price-filter-dropdown");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".price-filter-dropdown").removeClass("active");
      }
    });

    if ((window.location.href).indexOf('property\/' + this.props.ptypetag)) {

      // Infinite properties scroll
      $(window).scroll(function () {

        if ($("#myprevbut").length) {
          var top_of_element = $("#myprevbut").offset().top;
          var bottom_of_element = $("#myprevbut").offset().top + $("#myprevbut").outerHeight();
          var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
          var top_of_screen = $(window).scrollTop();

          if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
            $("#myprevbut").trigger("click");
          }
        }


      });
      // Infinite properties scroll
    }

    window.addEventListener("scroll", this.handleScroll, true)

    // load on top
    $(document).ready(function () {
      $("html, body").scrollTop(0);
    });
    // load on top

    //
    $(".property_sortby_asc").click(function () {
      $(".property_sortby_asc").addClass("active");
      $(".property_sortby_desc").removeClass("active");
    })

    $(".property_sortby_desc").click(function () {
      $(".property_sortby_desc").addClass("active");
      $(".property_sortby_asc").removeClass("active");
    })
    //

    // Sold filter
    $(".filtersearchsold").insertAfter(".defaultsoldfilter");
    // Sold filter

    if (isAuthenticated) {
      const getUserObjects = async () => {
        try {
          const userObjects = await getUserobjectData()
          this.setState({
            userObjects: userObjects.data.data
          })
          console.log("success");
        } catch (e) {
          console.log("e:", e)
        }
      }
      getUserObjects()
    }



  }
  //   clearFilter = () => {
  //       this.setState({ searchState: urlToSearchState("") });
  //       navigateGatsby(this.props.locationname)
  //   }


  render() {


    const arrowClick = () => {
      arrow = true
    }
    const handlerClick = () => {
    }

    //
    const clickHandle = (e) => {
      const li = e.target.closest('li');
      li.closest('ul').querySelectorAll('li').forEach(item => {
        if (item !== li) {
          item.classList.remove('active');
        }
      })
      e.target.closest('li').classList.toggle('active');
    }

    const capitalize = (s) => {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const capitalizeAll = (s) => {
      if (typeof s !== 'string') return ''
      return s.split(" ").map(c => _.upperFirst(c)).join(" ")
    }


    const searchParams = parseSearchUrl(this.props?.ptype, this.props?.fullpathname);

    const saveSearchParams = savedSearchParams(searchParams);

    if (searchParams.areas == "") {
      searchParams.areas = "Shropshire, Staffordshire and the West Midlands";
    }


    const h1 = propertyH1(searchParams, false);
    const introH1 = propertyH1(searchParams, true);

    const areaName = searchParams.areas;

    const pType = searchParams.pType;
    let propertyType = "";
    if (searchParams.type == "") {
      propertyType = "properties "
    } else {
      var typeReplace = searchParams.type
      switch (searchParams.type) {
        case "apartment":
          typeReplace = "apartments";
          break;
        case "house":
          typeReplace = "houses";
          break;
        case "bungalow":
          typeReplace = "bungalows";
          break;
        case "maisonette":
          typeReplace = "maisonettes";
          break;
        case "land":
          typeReplace = "lands";
          break;
        case "leasehold interest":
          typeReplace = "leasehold property";
          break;
        case "auction":
            typeReplace = "auctions";
            break;
        case "private-treaty":
            typeReplace = "Private Treaty";
        break;
        case "shared-ownership":
            typeReplace = "Shared Ownership";
        break;
      }
      propertyType = typeReplace;
    }

    var actionStr = ACTION_TYPES[pType];
    const actionDescStr = ACTION_DESC_TYPES[pType];
    var introArea = capitalizeAll(searchParams.areas).replace("And", "and");


    var action = `${actionStr}${introArea}`
    var description = `Looking for ${introH1}? Contact our property experts and get help to find the best property ${action}.`
    if (searchParams.type) {
      description = `Discover the wide range of ${introH1}. DB Roberts Estate Agents specialise in exclusive property ${action}.`
    }
    if (searchParams.price.min || searchParams.price.max) {
      description = `Find the best ${introH1} with DB Roberts,  Book an appointment with one of our specialists today to find the perfect property ${actionDescStr} anywhere in ${searchParams.areas}.`

    }
    if (searchParams.bedrooms) {
      description = `Find ${introH1}. DB Roberts Estate Agents will help you find exclusive property ${action}`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.type) {
      description = `Browse the latest ${introH1}. DB Roberts offers a wide range of ${propertyType} ${action}.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.bedrooms) {
      description = `Here is the wide collection of ${introH1}. Contact DB Roberts for all your property needs.`
    }
    if (searchParams.type && searchParams.bedrooms) {
      description = `Here is the finest collection of ${introH1} in ${introArea}, Our property experts are here to help you find the right property.`
    }
    if ((searchParams.price.min || searchParams.price.max) && searchParams.type && searchParams.bedrooms) {
      description = `Discover ${introH1} with DB Roberts, Contact DB Roberts estate agents for best deals.`
    }

    var intoCopy = `Search ${introH1} with DB Roberts Estate Agents. Refine your search using the filters above and for more information about ${propertyType} in ${introArea} contact us.`
    const isPageLoadBg = (typeof this.props.fullpathname === "undefined");

    // Geo toggle tablet & mobile
    const geoPinClick = (e) => {
      $(".property_map_pin").removeClass("active");
      $(".property_map_list").addClass("active");

      $(".property_list_results").addClass("d-none");
      $(".right-side").removeClass("mobile-none");
    }

    const geoToggleClick = (e) => {
      $(".property_map_list").removeClass("active");
      $(".property_map_pin").addClass("active");

      $(".property_list_results").removeClass("d-none");
      $(".right-side").addClass("mobile-none");
    }
    // Geo toggle tablet & mobile

    const filterRefine = (e) => {
      $(".filter-section").removeClass("refine");
      $("#filter-one").hide();
      $("#filter-two").show();
    }
    const filterRefineone = (e) => {
      $(".filter-section").addClass("refine");
      $("#filter-one").show();
      $("#filter-two").hide();
    }
    // var defaultStatus = ["For Sale"];
    // if (this.props.ptype === "lettings") {
    //   defaultStatus = ["To Let", "arrangingTenancy", "tenancyCurrent"];
    // }


    // console.log("areaName", areaName);
    let search_area = "";
    if (areaName != "Shropshire, Staffordshire and the West Midlands") {
      search_area = areaName.replace("-", " ");
      // console.log("search_area", search_area)
    }

    var defaultStatus = this.state.includeSoldinside ? ["For Sale", "Sold"] : ["For Sale"];
    if (this.props.ptype === "lettings") {
      defaultStatus = this.state.includeLetinside ? ["To Let", "Let Agreed", "arrangingTenancy", "tenancyCurrent"] : ["To Let", "arrangingTenancy", "tenancyCurrent"];
    }

    let mystatus = ''
    if(defaultStatus){
      if(Array.isArray(defaultStatus)){
        mystatus = '(status:"'+(defaultStatus).join('" OR status:"')+'")'
      } else {
        mystatus = '(status:"'+(defaultStatus)+'")'
      }
    }

    return (
      <React.Fragment>
        <UserObjectStoreProvider>
          {!isPageLoadBg &&
            <SeoResults title={h1} searchParams={searchParams} description={description} location={this.props.location} pcategorytype={this.props.pcategorytype} />
          }
          <InstantSearch
            indexName={index_name}
            searchClient={searchClient}
            searchState={this.state.searchState}
            onSearchStateChange={this.onSearchStateChange}
            createURL={createURL}
            showLoadingIndicator
            routing="true"
          >
            <div className="d-none">
              <CurrentRefinements
                transformItems={items =>
                  items.filter(({ attribute }) => !["searchType", "department"].includes(attribute))
                }
              />
              {/* <RefinementList
              attribute="publish"
              defaultRefinement={[true]}
            /> */}
              {/* <RefinementList
                attribute="searchType"
                defaultRefinement={[this.props.ptype]}
              />
              <RefinementList
                attribute="department"
                defaultRefinement={[this.props.pcategorytype]}
              />
              <RefinementList
                attribute="status"
                defaultRefinement={defaultStatus}
              /> 
              {search_area.length > 0 ?
                <RefinementList
                  attribute="address_summary"
                  defaultRefinement={[search_area]}
                /> : ''
              } */}
            </div>

            <div className={this.state.show ? "map-open" : "map-open2"}>
              {(!isMobile) && <div className="map-box">

                <MapResultsDesktop
                  ptype={this.props.ptype === "sales" && this.props.pcategorytype === "residential" ? "myResSaleProp"
                    : this.props.ptype === "lettings" && this.props.pcategorytype === "residential" ? "myResRentProp"
                      : ''
                  }
                  show={this.state.show}
                />

                {/* {(isMobile) &&
                <></>
              } */}
              </div>}

              <div
                className="right_block"
              >
                <InView {...inViewOptions} triggerOnce={true}>
                  {({ ref, inView }) => (
                    <>
                      {/* <FilterBlock showMapFn={this.showMap} show={this.state.show} /> */}
                      <motion.div
                        className={`search-result-filter ${(isMobile && this.state.show) ? "position-relative" : ""}`}
                        ref={ref}
                        initial="hidden"
                        animate="visible"
                        variants={fadeInFromBottom}
                      >
                        <SearchFilter type={this.props.ptype} searchState={this.state.searchState} />
                        <section className="filter d-none">
                          <div className="filter-field">
                            <Container>
                              <Row>
                                <Col className="filter-fixed ">
                                  <Form className="form-data">
                                    <SearchBox />
                                    <div className={this.state.filterOpen ? "filter-mobile_btn d-lg-none filter-up" : "filter-mobile_btn d-lg-none"} onClick={this.filterClick}>
                                      <span>Filter</span>
                                      <i className="icon-down"></i>
                                    </div>
                                    <div className={this.state.filterOpen ? "box-wrapper d-xl-flex d-block" : "box-wrapper d-xl-flex"}>
                                      <div className="select-boxes select-boxes-buy">
                                        <CustombedroomSelectbox attribute="bedroom" />
                                      </div>
                                      <div className="select-boxes">
                                        <CustomminpriceSelectbox attribute="price" type={this.props.ptype} />
                                      </div>
                                      <div className="select-boxes">
                                        <CustommaxpriceSelectbox attribute="price" type={this.props.ptype} />
                                      </div>
                                      <div className="select-boxes">
                                        <CustombuildingSelectbox attribute="building" />
                                      </div>
                                      <div className="d-none">
                                        <CustombuildingSelectbox attribute="tenure" />
                                      </div>
                                      <div className="d-none">
                                        <CustombuildingSelectbox attribute="disposal" />
                                      </div>
                                    </div>

                                  </Form>
                                </Col>
                              </Row>
                            </Container>
                          </div>
                        </section>
                      </motion.div>

                      <div
                        className={`search-result-filter1 ${(isMobile && this.state.show) ? "position-relative" : ""}`}
                      >
                        <section className="filter ">
                          <Container>
                            <Row>
                              <Col>
                                <div className="search-result-short">

                                  <div className="search-result-title">
                                    <h1> {h1.replace(/-/g, ' ')} <strong>(<CustomStats />)</strong>
                                      <span>
                                        <img src={infoIcon} className="info-icon-p" onClick={() => { this.setState({ showDesc: !this.state.showDesc }) }} />
                                      </span>

                                      <SaveItem type="search" searchParams={saveSearchParams} userObjects={this.state.userObjects}>
                                        <span class="btn-circle-blue position-relative">
                                          <i class="icon-like-blue ml-3 mt-2 icon-default"></i>
                                          <i class="icon-like-blue-fill ml-3 mt-2 icon-saved"></i>
                                        </span>
                                      </SaveItem>
                                    </h1>
                                    {/* <i className="icon-info-p" onClick={() => { this.setState({ showDesc: !this.state.showDesc }) }}></i> */}
                                  </div>

                                  <div className="filter-short justify-content-sm-start justify-content-between">
                                    <div className="switch-button map-btn-wrap" onClick={() => this.setShow()}>
                                      <label for="map-button">
                                        <span className={this.state.show ? "toggle-switch map-toggle" : "toggle-switch"}>
                                          <span className="toggle-switch-bar"></span>
                                        </span>
                                        <span className="toggle-text">Map {this.state.show ? "On" : "Off"}</span>
                                      </label>
                                    </div>
                                    {this.props.ptype === "lettings" ?
                                      // <CustomToggleRefinement
                                      //   attribute="status"
                                      //   label="Include Let"
                                      //   value={['Let Agreed']}
                                      //   defaultRefinement={includeSold}
                                      // />
                                      <div className="switch-button ">
                                        <label for="toggle-button">
                                          <input onChange={this.includeLetclick}
                                            type="checkbox" id="toggle-button"
                                            checked={this.state.includeLetinside ? "checked" : ""} />
                                          <span className="toggle-switch">
                                            <span className="toggle-switch-bar"></span>
                                          </span>
                                          <span className="toggle-text">Include Let</span>
                                        </label>
                                      </div>
                                      :
                                      // <CustomToggleRefinement
                                      //   attribute="status"
                                      //   label="Include Sold"
                                      //   value={['Sold']}
                                      //   defaultRefinement={includeSold}
                                      // />
                                      <div className="switch-button ">
                                        <label for="toggle-button">
                                          <input onChange={this.includeSoldclick}
                                            type="checkbox" id="toggle-button"
                                            checked={this.state.includeSoldinside ? "checked" : ""} />
                                          <span className="toggle-switch">
                                            <span className="toggle-switch-bar"></span>
                                          </span>
                                          <span className="toggle-text">Include Sold</span>
                                        </label>
                                      </div>
                                    }

                                    <CustomSortBy
                                      items={[
                                        { value: index_name + '_price_desc', label: 'Price desc', class: 'property_sortby_desc active' },
                                        { value: index_name, label: 'Price asc', class: 'property_sortby_asc' },
                                      ]}
                                      defaultRefinement={index_name+ '_price_desc'}
                                    />

                                    {/* <div className="pl-3">
                                  <ClearRefinements
                                  clearsQuery={true}
                                    transformItems={items =>
                                      items.filter(({ attribute }) => !["searchType", "department"].includes(attribute))
                                    }
                                    translations={{
                                      reset: 'Clear all',
                                    }}
                                  />
                                </div> */}
                                    {/* <button className="ml-2" onClick={this.clearFilter}><small>Clear All</small></button> */}
                                  </div>
                                </div>
                                {
                                  this.state.showDesc && <div className="search-result-description">{intoCopy}</div>
                                }


                              </Col>
                            </Row>

                          </Container>
                        </section>
                      </div>
                    </>
                  )}
                </InView>
                {((!this.state.show && !isMobile) || (this.state.show && !isMobile) || (isMobile && !this.state.show)) && <div className="property-card-list property_list_results" id="property_list_results">
                  <CustomInfiniteHits location={this.props.fullpathname} userObjects={this.state.userObjects} />
                  <Configure filters={`searchType:${this.props.ptype} AND department:${this.props.pcategorytype} AND ${mystatus}`} hitsPerPage={21} />
                  {/* <CustomNoStats /> */}
                  <LoadingIndicator />
                </div>}

                {(this.state.show && isMobile) &&
                  <>
                    {/* <MapResultsDesktop
                    mobile={true}
                    ptype={this.props.ptype === "sales" && this.props.pcategorytype === "residential" ? "myResSaleProp"
                    : this.props.ptype === "lettings" && this.props.pcategorytype === "residential" ? "myResRentProp"
                        : ''
                }
                /> */}
                    <MapMobile />
                    <Configure filters={`searchType:${this.props.ptype} AND department:${this.props.pcategorytype} AND ${mystatus}`} hitsPerPage={20} />
                  </>
                }
              </div>
            </div>
          </InstantSearch>
          <InView {...inViewOptions}>
            {({ ref, inView }) => (
              <motion.div
                className="get-property overflow-hidden"
                ref={ref}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                variants={containerVariants}
              >
                <Container>
                  <Row>
                    <Col xl={12}>
                      <div className="get-property-block">
                        <motion.h2 variants={fadeInFromRight}>Let’s start your property journey together.</motion.h2>
                        <motion.div className="btn-row" variants={fadeInFromBottom}>
                          <Link to={`/property-valuation/home-visit-valuation`} className="btn btn-primary">Book a Valuation <i className="icon-arrow"></i></Link>
                          <Link to={`/property/for-sale`} className="btn btn-primary">Find a Property <i className="icon-arrow"></i></Link>
                        </motion.div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </motion.div>
            )}
          </InView>
        </UserObjectStoreProvider>
      </React.Fragment>
    )
  }
}


export default PropertySearchSales
